import { CheckboxPanel_Label_default } from "./chunk-LCPHIR7V.js";
import { CheckboxPanel_default } from "./chunk-F5N2QNTD.js";

// src/components/CheckboxPanel/index.ts
var CheckboxPanelComponent = CheckboxPanel_default;
CheckboxPanelComponent.Label = CheckboxPanel_Label_default;
CheckboxPanelComponent.Label.displayName = "CheckboxPanel.Label";
export { CheckboxPanelComponent };